export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8626.41ad786b.jpg";